import React, { useCallback } from "react";

import { useResponsive } from "../../../../../hooks/useResponsive";
import { CustomButton } from "../../../../../components/Button/Button";
import DownArrow from "../../../../../styles/svg/date-range.svg";
import CustomMenu from "../../../../../components/Menu";
import WorkflowDateRangeFilter from "./DateRangeFilter";
import { useMissingStatusDateFilter } from "../../hooks/useMissingStatusDateFilter";

function DateRangeFilterButton() {
  const [openDateFilter, setOpenDateFilter] = React.useState(null);
  const isMobile = useResponsive("down", "md");
  const openDateFilterMenu = Boolean(openDateFilter);

  const handleClick = useCallback((event) => {
    setOpenDateFilter(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setOpenDateFilter(null);
  }, []);
  const { heading } = useMissingStatusDateFilter(handleClose);

  return (
    <div className={isMobile && "d-flex justify-content-end"}>
      <CustomButton
        variant="outlined"
        id="epics-board-dropdown"
        aria-haspopup="true"
        onClick={(event) =>handleClick(event)}
        endIcon={<img src={DownArrow} style={{ paddingRight: "2px" }} />}
        className="white-button report-date-range-filter-button"
      >
        <p className="date-range-filter-date">{heading}</p>
      </CustomButton>
      <CustomMenu
        id="user-menu"
        anchorEl={openDateFilter}
        open={openDateFilterMenu}
        onClose={handleClose}
        className="report-date-range-filter-menu"
      >
        <WorkflowDateRangeFilter onClose={handleClose} />
      </CustomMenu>
    </div>
  );
}
export default React.memo(DateRangeFilterButton);
